import React, { useState } from "react";
import WebinarDetails from "./knowmoreDeatils";
import PastWebinars from "./pastWebinar";
import RegisterModal from "./registerModal";
import "./style.scss";
import DoctorUpcomingWebinars from "./upcomingWebinar";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";

import { Dropdown } from "react-bootstrap";
import FilterIcon from "../../assets/FliterIcon.svg";
import DownloadReport from "../DownloadReport/DownloadReport";

const DoctorWebinar = () => {
  const [value, setValue] = useState(0);
  const [filterValue, setFilterValue] = useState("asc");
  const [filterPassedValue, setFilterPassedValue] = useState("desc");

  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      width: "100%",
      // backgroundColor: theme.palette.background.paper,
      backgroundColor: "white", //"#F5F5F5",
    },
    indicator: {
      backgroundColor: "red",
    },
  }));

  const StyledTab = makeStyles((theme) => ({
    indicator: {},
  }));

  const classes = useStyles();

  function a11yProps(index) {
    return {
      id: `scrollable-force-tab-${index}`,
      "aria-controls": `scrollable-force-tabpanel-${index}`,
    };
  }

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-force-tabpanel-${index}`}
        aria-labelledby={`scrollable-force-tab-${index}`}
        style={{ minHeight: "88vh" }}
        {...other}
      >
        {value === index && <Box p={3}>{children}</Box>}
      </div>
    );
  }
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="doctor-webinar-container bg-grey">
      <div>
        <div>
          <div className="bg-white">
            <div className="row">
              {/* <div className="col-12 header px-4 mt-3">Webinars</div> */}
              <div className="col-12 d-flex justify-content-between px-4">
                <div className="header mt-3">Webinars</div>
                <div className="mobile-sort">
                  {value === 0 ? (
                    <Dropdown className="filter-border">
                      <Dropdown.Toggle
                        style={{
                          background: "transparent",
                          border: "none",
                          margin: "0px",
                          fontSize: "19px",
                          color: "#fff",
                          // borderColor: "#D6DAE5",
                          backgroundColor: "#fff",
                        }}
                      >
                        {/* <i className="fa fa-filter" aria-hidden="true"></i> */}
                        <img src={FilterIcon} />
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="m-0">
                        <Dropdown.Item
                          onClick={() => {
                            setFilterValue("asc");
                          }}
                          style={{
                            fontSize: "13px",
                            padding: "10px 15px",
                            borderBottom: "1px solid #0000001A",
                          }}
                        >
                          <i
                            className={`fa fa-check mr-3 check-icon-filter ${
                              filterValue === "asc" ? "activeTab" : ""
                            }`}
                          ></i>
                          Oldest to Newest
                        </Dropdown.Item>

                        <Dropdown.Item
                          onClick={() => {
                            setFilterValue("desc");
                          }}
                          style={{
                            fontSize: "13px",
                            padding: "10px 15px",
                          }}
                        >
                          <i
                            className={`fa fa-check mr-3 check-icon-filter ${
                              filterValue === "desc" ? "activeTab" : ""
                            }`}
                          ></i>
                          Newest to Oldest
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  ) : (
                    <Dropdown className="filter-border">
                      <Dropdown.Toggle
                        style={{
                          background: "transparent",
                          border: "none",
                          margin: "0px",
                          fontSize: "19px",
                          color: "#fff",
                          // borderColor: "#D6DAE5",
                          backgroundColor: "#fff",
                        }}
                      >
                        {/* <i className="fa fa-filter" aria-hidden="true"></i> */}
                        <img src={FilterIcon} />
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="m-0">
                        <Dropdown.Item
                          onClick={() => {
                            setFilterPassedValue("asc");
                          }}
                          style={{
                            fontSize: "13px",
                            padding: "10px 15px",
                            borderBottom: "1px solid #0000001A",
                          }}
                        >
                          <i
                            className={`fa fa-check mr-3 check-icon-filter ${
                              filterPassedValue === "asc" ? "activeTab" : ""
                            }`}
                          ></i>
                          Oldest to New
                        </Dropdown.Item>

                        <Dropdown.Item
                          onClick={() => {
                            setFilterPassedValue("desc");
                          }}
                          style={{
                            fontSize: "13px",
                            padding: "10px 15px",
                          }}
                        >
                          <i
                            className={`fa fa-check mr-3 check-icon-filter ${
                              filterPassedValue === "desc" ? "activeTab" : ""
                            }`}
                          ></i>
                          New to Older
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  )}
                </div>
              </div>

              <div className="col-12 px-4 mt-3">
                <Tabs
                  className={classes.root}
                  value={value}
                  onChange={handleChange}
                  aria-label="simple tabs example"
                >
                  <Tab label="Upcoming Webinars" {...a11yProps(0)} />
                  <Tab label="Past Webinars" {...a11yProps(1)} />
                </Tabs>
              </div>
            </div>
          </div>
          <TabPanel value={value} index={0}>
            <DoctorUpcomingWebinars filterUpcomingValue={filterValue} />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <PastWebinars filterPassedValue={filterPassedValue} />
          </TabPanel>
        </div>
      </div>
      <div>
        {/* <DoctorUpcomingWebinars />
        <PastWebinars /> */}
        {/* <WebinarDetails />
        <RegisterModal show={false} /> */}
      </div>
      <DownloadReport />
    </div>
  );
};

export default DoctorWebinar;
